enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  LOGIN_IINDUSTRY = "loginIIndustry",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
}

//จะเหมือนใน c#
//ใช้เพื่อระบุ ระบบที่ใช้งาน
enum RefType {
  ProjectCourse = 0 /* โครงการ */,
  TrainingCourse = 1 /* หลักสูตร */,
  Consult = 2 /* ผู้เชี่ยวชาญ */,
  Contractorwork = 3 /* งานสัญญาจ้าง */,
  Matching = 4 /* จับคู่ธุรกิจ */,
  Event = 5 /* กิจกรรม */,
}

//จะเหมือนใน c#
//ใช้เพื่อระบุ ประเภทของ training course
enum TrainingCourseType {
  Online = 1,
  Onsite = 2,
  eLearning = 3,
}

//จะเหมือนใน c#
//ใช้เพื่อระบุ ประเภทของ ร่วมเป็นส่วนหนึ่งกับเรา
enum DipromJoinUsType {
  Consult = 1,
  Matching = 2,
  Marketplace = 3,
}

//จะเหมือนใน c#
// สถานะของเจ้าหน้าที่กรม (แต่เอามาใช้ร่วมกับงานอื่น ๆ ด้วย)
enum OfficerStatusType {
  WaitApprove = 0,
  Approve = 1,
  Reject = 2,
  CheckInformation = 3,
  Cancel = 4,
}

// สถานะโครงการของสัญญาจ้าง มาจากตาราง [cwt_project_status]
enum ContractorworkProjectStatus {
  InProgress = 1 /* อยู่ระหว่างดำเนินงาน */,
  Completed = 2 /* จบโครงการ */,
}

//ใช้ set ค่า param ล่าสุดของ form diprom
enum StateFormDiPromMutations {
  SET_G01_ID = "setG01Id",
  SET_G01_1_ID = "setG01_1Id",
}

//ใช้ set ค่า param ล่าสุดของ marketplace module
enum StateMarketplaceMutions {
  SET_SELLER_PRODUCT_ID = "setSellerProductId",
  SET_SELLER_ORDER_ID = "setSellerOrderId",
  SET_SELLER_STORE_ID = "setSellerStoreId",
}
export {
  Actions,
  Mutations,
  RefType,
  TrainingCourseType,
  StateFormDiPromMutations,
  StateMarketplaceMutions,
  DipromJoinUsType,
  OfficerStatusType,
  ContractorworkProjectStatus,
};
